<template>
    <a-table
        ref="childTable"
        row-key="id"
        class="childTable"

        :row-selection="childRowKeys"
        :columns="mergeColumns"
        :data-source="dataSource"
        :pagination="false">
        <span slot="gender" slot-scope="text, record">
            {{ text.gender === 1 ? '男' : '女' }}
        </span>
        <span slot="gradeName" slot-scope="text, record">
            {{ text.gradeName }}
        </span>
        <div style="max-width: 250px" slot="className" slot-scope="text, record">
            <!-- <div class="self_td" v-for="(item,index) in record.gradeClassList" :key="item.id">
                {{item.className}}
            </div> -->
            {{ text.className }}
        </div>
        <span slot="birthday" slot-scope="text, record">
            {{ text.birthday && text.birthday.split(" ")[0] }}
        </span>
        <span slot="enabled" slot-scope="text, record">
            {{ text.enabled ? '启用' : '禁用' }}
        </span>
    </a-table>
</template>

<script>
const mergeColumns = [
    {
        title: '学生姓名',
        key: "1",
        dataIndex: 'realName'
    },
    {
        title: '性别',
        key: "2",
        scopedSlots: {customRender: 'gender'}
    },
    {
        title: '年级',
        key: "3",
        scopedSlots: {customRender: 'gradeName'}
    },
    {
        title: '班级',
        key: "4",
        class: 'testClass',
        align: 'center',
        scopedSlots: {customRender: 'className'}
    },
    {
        title: '出生日期',
        key: "6",
        scopedSlots: {customRender: 'birthday'}
    },
    {
        title: '手机号',
        key: "5",
        dataIndex: 'mobile'
    },
    {
        title: '创建时间',
        key: "7",
        dataIndex: 'createTime',
    },
    {
        title: "状态",
        key: "8",
        scopedSlots: {customRender: 'enabled'}
    },
]
export default {
    name: 'ChildTable',
    props: {dataSource: Array, selectUser: Array, disabled: Boolean},
    data() {
        return {
            mergeColumns,
        }
    },
    created() {
        console.log(this.selectUser);
    },
    computed: {
        childRowKeys() {
            return {
                type: "radio",
                selectedRowKeys: this.selectUser,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectUser = selectedRowKeys;
                    this.$emit("selectUserChange", selectedRowKeys, selectedRows);
                },
                getCheckboxProps: record => ({
                    props: {
                        disabled: !this.disabled
                    }
                })
            };
        },
    }
}
</script>

<style>

</style>